import { paddingLarge, paddingMedium } from "src/styles/spacing";
import Loading from "../Loading";

const ListFooterComponent = ({ loading }: { loading: boolean }) => {
	if (!loading) return null;
	return (
		<Loading
			style={{
				marginTop: paddingLarge,
				marginBottom: paddingMedium,
				alignSelf: "center",
			}}
		/>
	);
};
export default ListFooterComponent;
